import {
  IonCardSubtitle,
  IonItem,
  IonList,
  IonListHeader,
  IonTitle
} from '@ionic/react';
import { ListSkeleton } from 'components/Skeleton/ListSkeleton';
import React from 'react';
import { useHistory } from 'react-router';
import WithdrawalItem from './WithdrawalItem';
import './WithdrawalsList.css';

type Props = {
  withdrawals: any;
  loading: Boolean;
  loaded: Boolean;
};

const WithdrawalsList: React.FC<Props> = ({ withdrawals, loading, loaded }) => {
  const history = useHistory();
  return (
    <IonList className={'withdrawals-list-root withdrawal-list'} lines="none">
      <IonListHeader className={'withdrawals-list-header'}>
        <div className={'view-all-container'} >
          <IonCardSubtitle slot={'start'}>
            Recent
          </IonCardSubtitle>
        </div>
      </IonListHeader>
      {loading && !loaded && <ListSkeleton rows={20} />}
      {withdrawals?.length > 0 ? (
        <>
          {withdrawals
            .slice()
            .slice(0, 4)
            .map((withdrawal:any, idx:number) => (
              <WithdrawalItem
                key={withdrawal.id}
                noLine={idx === withdrawals.length - 1}
                withdrawal={withdrawal}
              />
            ))}
            <IonItem className={'ion-no-padding ion-margin-bottom'} onClick={()=>history.push('/account/withdrawals/all')}>
              <IonTitle color="secondary">View All</IonTitle>
            </IonItem>
        </>
      ) : withdrawals?.length === 0 && (
        // @ts-ignore
        <IonItem className={'ion-no-padding ion-margin-bottom'} >
              <IonTitle color="secondary">No recent withdrawals</IonTitle>
        </IonItem>
      )}
    </IonList>
  );
};

export default WithdrawalsList;
